import React from "react"
import { isEmpty } from "lodash-es"
import { publicAnswersShape } from "utils/propTypeShapes"

const PublicAnswersList = ({ publicAnswers }) => (
  <div className="public-answers-list">
    {
      publicAnswers.sections.map(({ name, answers }) => {
        if (isEmpty(answers)) return null

        return (
          <div className="public-answers-list-section">
            {
              name && <span className="public-answers-list-section-name">{name}</span>
            }
            <div className="public-answers-list-section-answers">
              {
                answers.map(({ prompt, value }) => (
                  <div className="public-answers-list-section-answers-answer">
                    <span className="public-answers-list-section-answers-answer-prompt">{prompt}</span>
                    <p className="public-answers-list-section-answers-answer-value">{value}</p>
                  </div>
                ))
              }
            </div>
          </div>
        )
      })
    }
  </div>
)

PublicAnswersList.propTypes = {
  publicAnswers: publicAnswersShape,
}

export default PublicAnswersList
